import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import { content } from "@/lib/content";
import { deepMerge } from "@/lib/deepMerge";
import { useSiteConfig } from "@/context/SiteConfigContext";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const { config } = useSiteConfig();
  const [lang, setLang] = useState(() => localStorage.getItem("om_lang") || "en");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "ro" ? "en" : "ro";
      localStorage.setItem("om_lang", next);
      document.documentElement.lang = next;
      return next;
    });
  }, []);

  const set = useCallback((l) => {
    localStorage.setItem("om_lang", l);
    document.documentElement.lang = l;
    setLang(l);
  }, []);

  const t = useMemo(
    () => deepMerge(content[lang], config?.content?.[lang] || {}),
    [lang, config]
  );

  const value = useMemo(() => ({ lang, toggle, set, t }), [lang, toggle, set, t]);

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
